<h3>Hello Details</h3>

<div *ngIf="layer">
    <div>{{ layer.name }}</div>
    <div>{{ layer.ds_type_uid }}</div>
    <input type="number" [(ngModel)]="opacity" (change)="changeAlpha()"/>
</div>
<div *ngIf="photo">
    <div>{{ photo.name }}</div>
    <img vlink="image.png" [model]="photo" class="prev"/>
</div>
<div *ngIf="annot">
    <div>{{ annot.name }}</div>
    <div>{{ annot.ds_type_uid }}</div>
    <input type="number" [(ngModel)]="opacity" (change)="changeAlpha()"/>
</div>

<div>
    <button (click)="delete()">{{ annot ? 'Delete':'Remove from scene'}}</button>
</div>